export default __webpack_public_path__ + "static/groupingRows-27235b85a12c65819582a0e15d28d77f.gif";